import axios from 'axios';

//Création d'axios avec une url de base
export const axiosCoreGouv = axios.create({
    baseURL: 'https://api-adresse.data.gouv.fr/',
});
